import React from 'react';

const ChatHeader: React.FC = () => {
  return (
    <div className="p-4 pb-4 md:p-8 md:pb-4">
      <h1 className="text-xl md:text-3xl font-bold text-gray-900 mb-2">How can I help you today?</h1>
      <p className="text-sm md:text-base text-gray-600">Choose a task below or describe what you need</p>
    </div>
  );
};

export default ChatHeader;